import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AppstoreTwoToneSvg from "@ant-design/icons-svg/es/asn/AppstoreTwoTone";
import AntdIcon from "../components/AntdIcon";
var AppstoreTwoTone = function AppstoreTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AppstoreTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AppstoreTwoTone.displayName = 'AppstoreTwoTone';
}
export default /*#__PURE__*/React.forwardRef(AppstoreTwoTone);